module.exports = __webpack_public_path__ + "media/images/avatar/27-fbba5ea6bb926df10196d05bd9374d80.svg";